import { TrackEventArgsType, TrackEventNameType } from '../@types/schema';
import {
  compactObject,
  customParams,
  domParams,
  leadFormParams,
  pageParams,
  searchParams,
  windowParams,
} from './param-utils';

const transformParams = (eventName: TrackEventNameType, args: TrackEventArgsType) => {
  const search_params = searchParams(args);

  return compactObject({
    page: pageParams(args),
    domEventData: domParams(args),
    customEventData: customParams(eventName, args),
    pageRequestId: args.request_id || 'undefined',
    window: windowParams(),
    leadFormEventData: args.leadFormId ? leadFormParams(args) : null,
    course_search: Object.keys(search_params).length ? search_params : null,
  });
};

export default transformParams;
